<template>
  <ComponentCard title="Quiz" icon="solar:check-circle-linear">
    <BlockField :model-value="attrs.question" placeholder="Question" :read-only="readOnly" input-class="text-base font-bold text-[#1c4848]" @update:model-value="set({ question: $event })" />
    <div v-for="(option, i) in attrs.options" :key="i" class="flex items-center gap-2">
      <button
        type="button"
        role="radio"
        :aria-checked="attrs.correct === i"
        :aria-label="`Answer ${i + 1} is the right one`"
        :disabled="readOnly"
        class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors"
        :class="attrs.correct === i ? 'border-emerald-700 bg-emerald-700 text-white' : 'border-[#1c4848]/15 text-transparent hover:border-emerald-700/50'"
        @click="set({ correct: i })"
      ><iconify-icon icon="solar:check-read-linear" aria-hidden="true" /></button>
      <div class="min-w-0 flex-1"><BlockField :model-value="option" :placeholder="`Answer ${i + 1}`" :read-only="readOnly" input-class="text-sm text-[#1c4848]" @update:model-value="list.change(i, $event)" /></div>
      <button v-if="!readOnly && attrs.options.length > 2" type="button" class="flex h-7 w-7 items-center justify-center rounded-md text-[#1c4848]/50 hover:bg-red-50 hover:text-red-700" :aria-label="`Remove answer ${i + 1}`" @click="removeOption(i)"><iconify-icon icon="solar:close-circle-linear" aria-hidden="true" /></button>
    </div>
    <button v-if="!readOnly && attrs.options.length < 6" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add('')">+ Add an answer</button>
    <BlockField :model-value="attrs.explanation" placeholder="Why this is the right answer" :read-only="readOnly" input-class="text-sm leading-relaxed text-[#1c4848]/75" @update:model-value="set({ explanation: $event })" />
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props, 'options');

function removeOption(i) {
  const correct = props.attrs.correct;
  props.set({
    options: props.attrs.options.filter((_, j) => j !== i),
    correct: i === correct ? 0 : i < correct ? correct - 1 : correct,
  });
}
</script>
